import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    NOTIFICATION_LIST, GET_NOTIFICATION_LIST, GET_NOTIFICATION_TEMPLATE_LIST, NOTIFICATION_TEMPLATE_LIST,
    SEARCH_NOTIFICATION_BY_ID, NOTIFICATION_BY_ID, ADD_NOTIFICATION, ADD_NOTIFICATION_RESPONSE,
    UPDATE_NOTIFICATION, UPDATE_NOTIFICATION_RESPONSE, DELETE_NOTIFICATION, DELETE_NOTIFICATION_RESPONSE,
    SEARCH_NOTIFICATION_BY_FIELD, NOTIFICATION_BY_FIELD_LIST
} from "./actionTypes";

export class GetNotificationList implements Action {
    readonly type = GET_NOTIFICATION_LIST;
}

export class NotificationList implements Action {
    readonly type = NOTIFICATION_LIST;
    readonly payload = []
    constructor(notificationList: Array<any>) {
        this.payload = notificationList;
    }
}

export class SearchNotificationById implements Action {
    readonly type = SEARCH_NOTIFICATION_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class NotificationById implements Action {
    readonly type = NOTIFICATION_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SearchNotificationByField implements Action {
    readonly type = SEARCH_NOTIFICATION_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class NotificationByFieldList implements Action {
    readonly type = NOTIFICATION_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class GetNotificationTemplateList implements Action {
    readonly type = GET_NOTIFICATION_TEMPLATE_LIST;
}

export class NotificationTemplateList implements Action {
    readonly type = NOTIFICATION_TEMPLATE_LIST;
    readonly payload = []
    constructor(notificationTemplateList: Array<any>) {
        this.payload = notificationTemplateList;
    }
}

export class AddNotification implements Action {
    readonly type = ADD_NOTIFICATION;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class AddNotificationResponse implements Action {
    readonly type = ADD_NOTIFICATION_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class UpdateNotification implements Action {
    readonly type = UPDATE_NOTIFICATION;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class UpdateNotificationResponse implements Action {
    readonly type = UPDATE_NOTIFICATION_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export class DeleteNotification implements Action {
    readonly type = DELETE_NOTIFICATION;
    readonly payload = null;
    constructor(id: string) {
        this.payload = id;
    }
}

export class DeleteNotificationResponse implements Action {
    readonly type = DELETE_NOTIFICATION_RESPONSE;
    readonly payload: IServerResponse = null;
    constructor(resp) {
        this.payload = resp;
    }
}

export type Actions = GetNotificationList | NotificationList | SearchNotificationById | NotificationById | GetNotificationTemplateList | NotificationTemplateList |
    AddNotification | AddNotificationResponse | UpdateNotification | UpdateNotificationResponse | DeleteNotification | DeleteNotificationResponse
    | SearchNotificationByField | NotificationByFieldList;
